import type { LogsStatusType } from '~/types';

export const walletStatuses: LogsStatusType[] = [
  { value: 1, text: 'nonRegistered', theme: 'danger', icon: 'Support' },
  { value: 2, text: 'incomplete', theme: 'danger', icon: 'Close' },
  { value: 3, text: 'rejected', color: 'error', icon: 'error_outline' },
  { value: 5, text: 'kyc1', theme: 'warning', icon: 'Clock', subStatuses: [2] },
  { value: 6, text: 'kyc2', theme: 'success', icon: 'Check', subStatuses: [3] },
  {
    value: 7,
    text: 'kyc3PendingVerification',
    theme: 'warning',
    icon: 'Clock',
    subStatuses: [4]
  },
  {
    value: 8,
    text: 'kycExpired',
    theme: 'warning',
    icon: 'Exclamation',
    subStatuses: [5]
  },
  { value: 10, text: 'blocked', theme: 'danger', icon: 'Block' },
  { value: 12, text: 'closed', theme: 'neutral', icon: 'Close' },
  {
    value: 13,
    text: 'kyc3MissingDocuments',
    theme: 'warning',
    icon: 'Clock',
    subStatuses: [4]
  },
  { value: 14, text: 'oneTime', theme: 'info', icon: 'ClockDotted' },
  { value: 16, text: 'tech', theme: 'success', icon: 'Check' }
];

export const thresholdWalletStatuses = [
  { value: 1, text: 'nonRegistered', theme: 'danger', icon: 'Support' },
  { value: 2, text: 'incomplete', theme: 'danger', icon: 'Close' },
  { value: 3, text: 'rejected', color: 'error', icon: 'error_outline' },
  { value: 5, text: 'kyc1', theme: 'warning', icon: 'Clock', subStatuses: [2] },
  { value: 6, text: 'kyc2', theme: 'success', icon: 'Check', subStatuses: [3] },
  {
    value: 7,
    text: 'kyc3PendingVerification',
    theme: 'warning',
    icon: 'Clock',
    subStatuses: [4]
  },
  {
    value: 8,
    text: 'kycExpired',
    theme: 'warning',
    icon: 'Exclamation',
    subStatuses: [5]
  },
  { value: 10, text: 'blocked', theme: 'danger', icon: 'Block' },
  { value: 12, text: 'closed', theme: 'neutral', icon: 'Close' },
  {
    value: 13,
    text: 'kyc3MissingDocuments',
    theme: 'warning',
    icon: 'Clock',
    subStatuses: [4]
  },
  { value: 14, text: 'oneTime', theme: 'info', icon: 'ClockDotted' },
  { value: 16, text: 'tech', theme: 'success', icon: 'Check' }
];
